// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"72":"Cart","187":"NotFound","275":"Product"}[chunkId] + "." + {"72":"60cf80a6","187":"fae0b000","275":"95ee5a50"}[chunkId] + ".chunk.css";
};